import { CardContent, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardTitle from "@saleor/components/CardTitle";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
// import FormSpacer from "@saleor/components/FormSpacer";
import Hr from "@saleor/components/Hr";
import { commonMessages } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { CurrencyratePageFormData } from "../CurrencyratePage/CurrencyratePage";

export interface CurrencyratePropertiesProps {
  data: CurrencyratePageFormData;
  disabled: boolean;
  onChange: (event: React.ChangeEvent<any>) => void;
}
const CurrencyrateProperties: React.FC<CurrencyratePropertiesProps> = ({
  data,
  disabled,
  onChange
}) => {
  const intl = useIntl();
  return (
    <Card>
      <CardTitle title={intl.formatMessage(commonMessages.properties)} />
      <CardContent>
        <Typography variant="subtitle1">
          <FormattedMessage
            defaultMessage="Property of Currency"
            description="Property of currency exchange rate"
          />
        </Typography>
        <Hr />
        {/* <ControlledCheckbox
          name={
            "isPrimaryExchangeRateCurrency" as keyof CurrencyratePageFormData
          }
          label={intl.formatMessage({
            defaultMessage: "isPrimaryExchangeRateCurrency",
            description: "isPrimaryExchangeRateCurrency"
          })}
          checked={data.isPrimaryExchangeRateCurrency}
          onChange={onChange}
          disabled={disabled}
        />

        <FormSpacer />
        <ControlledCheckbox
          name={"isPrimaryStoreCurrency" as keyof CurrencyratePageFormData}
          label={intl.formatMessage({
            defaultMessage: "isPrimaryStoreCurrency",
            description: "isPrimaryStoreCurrency"
          })}
          checked={data.isPrimaryStoreCurrency}
          onChange={onChange}
          disabled={disabled}
        />
        <FormSpacer /> */}
        <ControlledCheckbox
          name={"isPublished" as keyof CurrencyratePageFormData}
          label={intl.formatMessage({
            defaultMessage: "isPublished",
            description: "isPublished"
          })}
          checked={data.isPublished}
          onChange={onChange}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
};

export default CurrencyrateProperties;
